import VuexPersistence from 'vuex-persist';

export const vuexPersistLocalStorage = new VuexPersistence<any>({
  storage: window.localStorage,
  reducer: (state: any) => {
    return {
      CmsStore: state.CmsStore,
      OrderStore: {
        driverNotice: state.OrderStore.driverNotice,
        deliveryAddress: state.OrderStore.deliveryAddress,
        billingAddress: state.OrderStore.billingAddress,
        deliverySlot: state.OrderStore.deliverySlot,
        deliveryMethod: state.OrderStore.deliveryMethod,
        paymentMethod: state.OrderStore.paymentMethod,
        confirmationMailAddress: state.OrderStore.confirmationMailAddress,
        birthday: state.OrderStore.birthday,
        languageCode: state.OrderStore.languageCode,
      },
    };
  },
});
